<template>
  <validation-observer v-slot="{ handleSubmit }" ref="contactObserver">
    <div class="modal-card enhancify grid-module">
      <header class="modal-card-head">
        <h2 class="modal-card-title">{{ id ? 'Edit event'
          : ' Create event' }}</h2>
        <button class="modal-close is-large" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <validation-provider v-slot="{ errors }"
                               :rules="{ required: true, regex: /^[a-zA-Z0-9-]+$/ }">
            <b-field v-model="type"
                     label="Event"
                     :type="{ 'is-danger': errors.length }"
                     :message="errorMessage(errors)">
              <b-input v-model="type"
                       maxlength="100"
                       @blur="()=>{ trimSpaces('subject') }"></b-input>
            </b-field>
          </validation-provider>
        </form>
      </section>
      <footer class="modal-card-foot buttons is-right">
          <button class="button button-cancel" type="button" @click="cancel">Cancel</button>
          <button class="button is-success"
                  @click="handleSubmit(submit)">{{ id ? 'Update' : 'Add' }}</button>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { mapMutations } from 'vuex';
import { get } from 'lodash';
import { postEmailTemplateType } from '@/api/emails';
import * as MUTATIONS from '../../store/mutations';

export default {
  name: 'EmailTemplateType',
  props: ['typeID', 'typeName'],
  data() {
    return {
      id: this.typeID || null,
      type: this.typeName || null,
    };
  },

  methods: {
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),

    errorMessage(error) {
      return error[0] === '{field} is not valid'
        ? 'Please use letters (a-z), numbers (0-9), dash'
        : error;
    },

    async submit() {
      this.preloader(true);
      try {
        const { data } = await postEmailTemplateType({ id: this.id, type: this.type });
        this.$emit('submit', { context: this, type: data });
        this.$emit('close');
      } catch (err) {
        const error = get(err, 'response.data.message', null);
        if (error) {
          this.$buefy.toast.open({ message: error, type: 'is-danger', duration: 3000 });
        } else {
          this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com' });
        }
      } finally {
        this.preloader(false);
      }
    },
    cancel() {
      this.$emit('close');
    },
    trimSpaces(field) {
      if (this[field]) {
        this[field] = this[field].replace(/([\s]+)/gu, ' ').replace(/^[\s]|[\s]$/gu, '');
      }
    },

  },
};
</script>

<style scoped lang="stylus">
.modal-card.grid-module
  height unset
.modal-card
  .modal-card-title
    margin-bottom 0
    font-size 30px
  .modal-card-body
    max-height 600px

.modal-card-body >>> label.label
  font-weight 400
.buttons:last-child
  margin-bottom unset
.modal-card-body >>> textarea.textarea:not(.is-danger)
  box-shadow none
  border-color #8fa7b3
.modal-card-body >>> select
  border-color #8fa7b3
.modal-card-body >>> select:hover
  border-color #8fa7b3

footer.modal-card-foot
  padding 12px
  justify-content end
button.button
  width 135px
  height 46px
  border 1px solid #23D160
  font-size 19px
  text-transform uppercase
  margin-bottom 0
.button.button-cancel
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white
.button.is-success
  border none
</style>
